import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Blog.css";

// Blog Post Data
const blogPosts = [
  { id: 1, title: "DIAMOND EARRINGS", category: "Earrings", image: "/assets/blogearringimage.jpeg" },
  { id: 2, title: "TRENDY RINGS", category: "Rings", image: "/assets/blogringimages.jpeg" },
  { id: 3, title: "GOLD NECKLACE", category: "Necklaces", image: "/assets/weddingnecklace.jpeg" },
  { id: 4, title: "GOLD EARRINGS", category: "Earrings", image: "/assets/GOLDEARRINGS2.jpeg" },
  { id: 5, title: "DIAMOND PENDANTS", category: "Pendants", image: "/assets/blogPENDANTSimage.jpeg" },
  { id: 6, title: "GOLD BANGLES", category: "Bangles", image: "/assets/blogGOLDBANGLESimage.jpeg" },
  { id: 7, title: "WEDDING NECKLACES", category: "Necklaces", image: "/assets/blogWEDDINGNECKLACESimage.jpeg" },
  { id: 8, title: "GOLD CHAIN", category: "Chains", image: "/assets/goldchains.png" },
];

const categories = ["All", "Earrings", "Rings", "Necklaces", "Pendants", "Bangles", "Chains"];

const Blog = () => {
  const [filteredPosts, setFilteredPosts] = useState(blogPosts);
  const [activeCategory, setActiveCategory] = useState("All");

  useEffect(() => {
    AOS.init({ duration: 1000 });

    // Preload images
    blogPosts.forEach((post) => {
      const img = new Image();
      img.src = post.image;
    });
  }, []);

  const handleFilter = (category) => {
    setActiveCategory(category);
    if (category === "All") {
      setFilteredPosts(blogPosts);
    } else {
      setFilteredPosts(blogPosts.filter((post) => post.category === category));
    }
  };

  return (
    <div id="rs-blog" className="blog-section">
      <div className="blog-container">
        <h1 className="blog-title">Shop By Category</h1>

        {/* Category Filter */}
        <div className="category-filter">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`category-btn ${activeCategory === cat ? "active" : ""}`}
              onClick={() => handleFilter(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Blog Grid */}
        <div className="blog-grid">
          {filteredPosts.map((post) => (
            <div className="blog-card" key={post.id} data-aos="fade-up">
              <div className="blog-img-container">
                <img
                  src={`${post.image}?${new Date().getTime()}`} // Force reload
                  className="blog-image"
                  alt={post.title}
                  loading="eager" // Force immediate loading
                  onError={(e) => {
                    e.target.src = "/path/to/placeholder-image.jpg"; // Fallback image
                  }}
                />
                <div className="overlay">{post.title}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;